export const TripInformationFieldNames = {
  TripOriginalOrigin: 'tripOriginalOrigin',
  TripFinalDestination: 'tripFinalDestination',
  TripOrigin: 'tripOrigin',
  TripDestination: 'tripDestination',
  TripBaseRegisteredWeight: 'tripBaseRegisteredWeight',
  TripRoute: 'tripRouteField',
  TripMileage: 'tripMileage',
  TripIncludesReturnTrip: 'tripIncludesReturnTrip',
  TripReturnDestination: 'tripReturnDestination',
  TripReturnRoute: 'tripReturnRouteField',
  TripReturnMileage: 'tripReturnMileage',
  EffectiveDate: 'effectiveDate',
  EffectiveDateTime: 'effectiveDateTime',
} as const;

export type PermitTripData = {
  [TripInformationFieldNames.TripOrigin]?: string;
  [TripInformationFieldNames.TripDestination]?: string;
  [TripInformationFieldNames.TripBaseRegisteredWeight]?: number;
  [TripInformationFieldNames.TripRoute]?: string;
  [TripInformationFieldNames.TripMileage]?: number;
  [TripInformationFieldNames.TripIncludesReturnTrip]?: boolean;
  [TripInformationFieldNames.TripReturnDestination]?: string;
  [TripInformationFieldNames.TripReturnRoute]?: string;
  [TripInformationFieldNames.TripReturnMileage]?: number;
  [TripInformationFieldNames.EffectiveDate]?: string;
  [TripInformationFieldNames.EffectiveDateTime]?: string;
};

export type TripStages = Record<string, PermitTripData>;

export type TripInformationFields = {
  [TripInformationFieldNames.TripOriginalOrigin]?: string;
  [TripInformationFieldNames.TripFinalDestination]?: string;
  trips?: TripStages;
};
export const StateTripFields = [
  TripInformationFieldNames.TripOrigin,
  TripInformationFieldNames.TripDestination,
  TripInformationFieldNames.TripBaseRegisteredWeight,
  TripInformationFieldNames.TripRoute,
  TripInformationFieldNames.TripMileage,
  TripInformationFieldNames.TripIncludesReturnTrip,
  TripInformationFieldNames.TripReturnDestination,
  TripInformationFieldNames.TripReturnRoute,
  TripInformationFieldNames.TripReturnMileage,
] as const;
